export const requiredFieldStyle = {
  ':after': {
    content: "'*'",
    paddingLeft: '2px',
    color: 'inherit',
  },
};

export const requiredBeforeBindFieldStyle = {
  ':after': {
    content: "'†'",
    paddingLeft: '2px',
    color: 'inherit',
  },
};
